'use strict';
/**
 * Return SVG mask content to be used inside an SVG DEF element
 *
 * @param {string} maskId id of the MASK element to reference on the masked media element
 * @param {string} svgId id of the top SVG element container of the content
 * @param {string} svg masking content
 * @param {{x: string|number, y: string|number, width: string|number, height: string|number, transform: *, style:*}} attributes
 * @param {boolean} [isClip] if true the mask will be forced into alpha mode/type
 * @param {number} [version=1] version of SVG mask implementation to use
 * @return {string}
 */

function getMask(maskId, svgId, svg, attributes, isClip, version) {
  if (version === void 0) {
    version = 1;
  }

  var width = attributes.width,
      height = attributes.height,
      x = attributes.x,
      y = attributes.y,
      transform = attributes.transform,
      style = attributes.style;
  var transformStr = transform ? " transform=\"" + transform + "\"" : '';
  var styleStr = style ? " style=\"" + style + "\"" : '';
  var bleach = "<style>#" + svgId + " * {fill: #fff; stroke: #fff; stroke-width: 0;}</style>";
  var filterId;

  if (version > 1) {
    filterId = svgId + "-bleach";
    bleach = "<filter id=\"" + filterId + "\"><feColorMatrix type=\"matrix\"\n    values=\"0 0 0 0 1\n            0 0 0 0 1\n            0 0 0 0 1\n            0 0 0 1 0\"/></filter>";
  }

  return (isClip ? bleach : '') + "\n<mask id=\"" + maskId + "\">\n    <use " + (filterId ? "filter=\"url(#" + filterId + ")\" " : '') + "id=\"" + svgId + "-use\" xlink:href=\"#" + svgId + "\" width=\"" + width + "\" height=\"" + height + "\" x=\"" + x + "\" y=\"" + y + "\"" + transformStr + styleStr + "></use>\n</mask>\n" + svg + "\n";
}

var symbols = /[\r\n%#()<>?\[\\\]^`{|}]/g;
/**
 * Returns a data URI SVG encoded for CSS <url> value
 *
 * @param {string} svg content of the SVG
 * @return {string} encoded CSS url() value
 */

function encodeSVG(svg) {
  // Use single quotes instead of double to avoid encoding.
  var escaped = svg.replace(/"/g, '\'').replace(/>\s+</g, '><').replace(/\s{2,}/g, ' ').replace(symbols, encodeURIComponent);
  return "url(\"data:image/svg+xml," + escaped + "\")";
}
/**
 * Returns Object with mask CSS properties
 *
 * @param {string} svg
 * @param {{x: string, y: string, width: string, height: string}} attributes
 * @return {{maskRepeat: string, maskPosition: string, maskSize: string, maskImage: string}}
 */


function getCSSMask(svg, attributes) {
  var _ref;

  var width = attributes.width,
      height = attributes.height,
      x = attributes.x,
      y = attributes.y;
  var maskImage = encodeSVG(svg);
  var maskRepeat = 'no-repeat';
  var maskPosition = x + " " + y;
  var maskSize = width + " " + height;
  var webkitPrefix = 'Webkit';
  return _ref = {}, _ref[webkitPrefix + "MaskImage"] = maskImage, _ref[webkitPrefix + "MaskPosition"] = maskPosition, _ref[webkitPrefix + "MaskSize"] = maskSize, _ref[webkitPrefix + "MaskRepeat"] = maskRepeat, _ref.maskImage = maskImage, _ref.maskPosition = maskPosition, _ref.maskSize = maskSize, _ref.maskRepeat = maskRepeat, _ref;
}

module.exports = {
  getMask: getMask,
  getCSSMask: getCSSMask
};
//# sourceMappingURL=svgMask.js.map